module.exports = "mutation ($id: ID!) {\n  LeadDelete(id: $id) {\n    id\n  }\n}\n"